import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis',
  standalone: false,
})
export class EllipsisPipe implements PipeTransform {
  transform(value: string, args?: number): string {
    if (value == null || args == null) {
      return value;
    }
    // ensure is a string value and not array of values (workaround for unhandled condition fields)
    value = Array.isArray(value) ? value.filter(Boolean).join() : value;
    if (value.length > args) {
      return value.substring(0, args) + '...';
    } else {
      return value;
    }
  }
}
